/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  company_uuid: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .nullable(),
});
